import React, { useState, useEffect, useRef } from 'react';
import './ListingFilterBar.css';

const ListingFilterBar = ({
    priceSort = '',
    onPriceSortChange,
    isTopRated = false,
    onTopRatedToggle,
    isVerifiedOnly = false,
    onVerifiedToggle,
}) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown on click outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };

        if (isDropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            document.addEventListener('touchstart', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('touchstart', handleClickOutside);
        };
    }, [isDropdownOpen]);

    const handleSortSelect = (sortValue) => {
        if (onPriceSortChange) {
            onPriceSortChange(sortValue);
        }
        setIsDropdownOpen(false);
    };

    const getFilterByLabel = () => {
        if (priceSort === 'low_to_high') return 'Low to High';
        if (priceSort === 'high_to_low') return 'High to Low';
        return 'Filter by';
    };

    const isSortActive = Boolean(priceSort);

    return (
        <div className="listing-filter-bar">
            {/* 1. Filter by Dropdown */}
            <div className="listing-filter-dropdown-container" ref={dropdownRef}>
                <button
                    type="button"
                    className={`listing-filter-btn listing-filter-dropdown-toggle ${isSortActive ? 'listing-filter-btn--active' : ''}`}
                    onClick={() => setIsDropdownOpen((prev) => !prev)}
                    aria-expanded={isDropdownOpen}
                    aria-label="Filter by price options"
                >
                    <span className="listing-filter-label">{getFilterByLabel()}</span>
                    <i className={`bi bi-chevron-down listing-filter-arrow ${isDropdownOpen ? 'listing-filter-arrow--open' : ''}`} />
                </button>

                {isDropdownOpen && (
                    <div className="listing-filter-dropdown-menu">
                        <button
                            type="button"
                            className={`listing-filter-menu-item ${!priceSort ? 'listing-filter-menu-item--active' : ''}`}
                            onClick={() => handleSortSelect('')}
                        >
                            <span>Default</span>
                            {!priceSort && <i className="bi bi-check2 text-primary"></i>}
                        </button>
                        <button
                            type="button"
                            className={`listing-filter-menu-item ${priceSort === 'low_to_high' ? 'listing-filter-menu-item--active' : ''}`}
                            onClick={() => handleSortSelect('low_to_high')}
                        >
                            <span>Low to High</span>
                            {priceSort === 'low_to_high' && <i className="bi bi-check2 text-primary"></i>}
                        </button>
                        <button
                            type="button"
                            className={`listing-filter-menu-item ${priceSort === 'high_to_low' ? 'listing-filter-menu-item--active' : ''}`}
                            onClick={() => handleSortSelect('high_to_low')}
                        >
                            <span>High to Low</span>
                            {priceSort === 'high_to_low' && <i className="bi bi-check2 text-primary"></i>}
                        </button>
                    </div>
                )}
            </div>

            {/* 2. Top Rated Button */}
            <button
                type="button"
                className={`listing-filter-btn ${isTopRated ? 'listing-filter-btn--active' : ''}`}
                onClick={onTopRatedToggle}
                aria-pressed={isTopRated}
                aria-label="Filter by Top Rated"
            >
                <i className={`bi bi-star-fill listing-filter-star-icon ${isTopRated ? 'text-warning' : 'text-dark'}`} />
                <span>Top Rated</span>
            </button>

            {/* 3. Verified Button (Styled after Jd Verified from reference) */}
            <button
                type="button"
                className={`listing-filter-btn ${isVerifiedOnly ? 'listing-filter-btn--active' : ''}`}
                onClick={onVerifiedToggle}
                aria-pressed={isVerifiedOnly}
                aria-label="Filter by Aadhaar Verified vendors only"
            >
                <i className="bi bi-check-lg listing-filter-verified-icon" />
                <span>Verified</span>
            </button>
        </div>
    );
};

export default ListingFilterBar;
